import { ReqX } from "IZOX/STATIC";

class PublicMessages {

  static async SubmitForm(formData){
    let res = await ReqX.SendBE("/Web/PublicMessages/Submit", formData);
    return res;
  }

}

export default PublicMessages;